/** @jsxImportSource theme-ui @jsxRuntime classic */
import { AnchorSection, TicketCarousel, Ticket } from '@tishman/components';
import invariant from 'invariant';
import React from 'react';

import { usePageData } from '../utils';

import type { ComponentPropsWithoutRef } from 'react';

export default function RinkTicketOfferingsBlock(
  props: ComponentPropsWithoutRef<typeof AnchorSection>,
): React.JSX.Element {
  const { sanityTicketCategory } = usePageData<Queries.AttractionRinkQuery>();

  invariant(sanityTicketCategory, 'Rink ticket data is required!');
  const { tickets } = sanityTicketCategory;
  invariant(tickets?.length, 'Rink ticket offerings are required!');

  return (
    <AnchorSection {...props}>
      <TicketCarousel
        tickets={sanityTicketCategory.tickets as readonly Readonly<Ticket>[]}
        title="Ticket Offerings"
      />
    </AnchorSection>
  );
}
